import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Table } from "reactstrap";


function ForexTransactions({ status, showCredit, tab }) {
  const { t } = useTranslation();
  return (<div className="table-responsive">
    <Table className="table table-borderless mb-0">
      <thead>
        <tr className="text-center">
          <th></th>
          <th>{t("Pending")}</th>
          <th>{t("Rejected")}</th>
          <th>{t("Approve")}</th>
        </tr>
      </thead>
      <tbody className="text-center">
        <tr>
          <th className="text-start" scope="row">
            <Link to={`/transactions/deposit?tab=${tab}`}>
              {t("Deposit")}
            </Link>
          </th>
          <td>
            <Link to={`/transactions/deposit?status=${"PENDING"}&tab=${tab}`}>
              {status?.DEPOSIT?.PENDING ?? 0}
            </Link>
          </td>
          <td>
            <Link to={`/transactions/deposit?status=${"REJECTED"}&tab=${tab}`}>
              {status?.DEPOSIT?.REJECTED ?? 0}
            </Link>
          </td>
          <td>
            <Link to={`/transactions/deposit?status=${"APPROVED"}&tab=${tab}`}>
              {status?.DEPOSIT?.APPROVED ?? 0}
            </Link>
          </td>
        </tr>
        <tr>
          <th className="text-start" scope="row">
            <Link to={`/transactions/withdrawals?tab=${tab}`}>
              {t("Withdrwals")}
            </Link>
          </th>
          <td>
            <Link to={`/transactions/withdrawals?status=${"PENDING"}&tab=${tab}`}>
              {status?.WITHDRAW?.PENDING ?? 0}
            </Link>
          </td>
          <td>
            <Link to={`/transactions/withdrawals?status=${"REJECTED"}&tab=${tab}`}>
              {status?.WITHDRAW?.REJECTED ?? 0}
            </Link>
          </td>
          <td>
            <Link to={`/transactions/withdrawals?status=${"APPROVED"}&tab=${tab}`}>
              {status?.WITHDRAW?.APPROVED ?? 0}
            </Link>
          </td>
        </tr>
        {/* <tr>
          <th className="text-start" scope="row">
            <Link to={`/transactions/internal-transfer?tab=${tab}`}>
              {t("Internal Transfers")}
            </Link>
          </th>
          <td>
            <Link to={`/transactions/internal-transfer?status=${"PENDING"}&tab=${tab}`}>
              {status?.INTERNAL_TRANSFER?.PENDING ?? 0}
            </Link>
          </td>
          <td>
            <Link to={`/transactions/internal-transfer?status=${"REJECTED"}&tab=${tab}`}>
              {status?.INTERNAL_TRANSFER?.REJECTED ?? 0}
            </Link>
          </td>
          <td>
            <Link to={`/transactions/internal-transfer?status=${"APPROVED"}&tab=${tab}`}>
              {status?.INTERNAL_TRANSFER?.APPROVED ?? 0}
            </Link>
          </td>
        </tr> */}
        {/* {showCredit && <tr>
          <th className="text-start" scope="row">
            <Link to={"/transactions/credit"}>
              {t("Credits")}
            </Link>
          </th>
          <td>
            <Link to={`/transactions/credit?status=${"PENDING"}`}>
              {status?.CREDIT?.PENDING ?? 0}
            </Link>
          </td>
          <td>
            <Link to={`/transactions/credit?status=${"REJECTED"}`}>
              {status?.CREDIT?.REJECTED ?? 0}
            </Link>
          </td>
          <td>
            <Link to={`/transactions/credit?status=${"APPROVED"}`}>
              {status?.CREDIT?.APPROVED ?? 0}
            </Link>
          </td>
        </tr>} */}
      </tbody>
    </Table>
  </div>  );
}

export default ForexTransactions;